import Vue from 'vue';
import Router from 'vue-router';

//A-Z
import Home from './views/Home.vue';
import Register from '@/views/Register/Register.vue';
import Profile from '@/views/Profile.vue';
import EditProfile from '@/views/EditProfile.vue';
import Reward from '@/views/Reward.vue';
import Campaign from './views/Campaign.vue';
import CampaignService from './views/CampaignService.vue';
import StoreLocation from './views/StoreLocation.vue';
import CampaignGift from './views/module/Giftlist/page/CampaignGift.vue';
import GiftDetail from './views/module/Detail/GiftDetail.vue';
import FreeGiftDetail from './views/module/Detail/FreeGiftDetail.vue';
import TermsAndConditions from './views/TermsAndConditions.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import ContactUs from './views/ContactUs.vue';
import LineLogin from './views/module/Linelogin/LineLogin.vue';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'default',
            component: Home
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
        },
        {
            path: "/campaign/:campaignId",
            name: "campaign",
            component: Campaign,
        },
        {
            path: "/campaignservice/:configlist/:catename/:cateId",
            name: "campaignservice",
            component: CampaignService,
        },
        {
            path: "/booking",
            name: "reward",
            component: Reward,
        },
        {
            path: "/booking/:page",
            name: "reward-page",
            component: Reward,
        },
        {
            path: "/storelocation",
            name: "storelocation",
            component: StoreLocation,
        },
        {
            path: "/giftlist/:tap?",
            name: "giftlist",
            component: CampaignGift,
        },
        {
            path: '/giftdetail/:campaignId',
            name: '/giftdetail',
            component: GiftDetail
        },
        {
            path: '/freegiftdetail/:campaignId',
            name: '/freegiftdetail',
            component: FreeGiftDetail
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/editprofile',
            name: 'editprofile',
            component: EditProfile,
        },
        {
            path: '/termsandconditions',
            name: 'termsandconditions',
            component: TermsAndConditions,
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: PrivacyPolicy,
        },
        {
            path: '/contactus',
            name: 'contactus',
            component: ContactUs,
        },
        {
            path: '/landing/line',
            name: 'linelogin',
            component: LineLogin,
        }
    ]
})
